import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { _ResourceResourceCostCatalog } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { ResourceCostSelect } from "../../../ResourceCost/ResourceCostSelect";
import { EditorResourceCost } from "../../../ResourceCost/EditorResourceCost";

interface Props {
    idLabour: number;
}


export const ResourceResourceCostCatalog = ({ idLabour }: Props) => {

    const ResourceResourceCostCatalog = useDataBean(_ResourceResourceCostCatalog);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idLabour])

    const getLista = () => {

        ResourceResourceCostCatalog.instance.getResourceResourceCostCatalog(idLabour).then(
            (resp: any) => {
                if (resp) {
                    let x = resp;
                    x.forEach((user) => {
                        user.DataBeanProperties.CostingCenter = (user.DataBeanProperties.CostingCenterCode ?? "") + "-" + (user.DataBeanProperties.CostingCenterName ?? "");

                    });
                    setLista(x)
                }
            }
        )

    }

    const create = () => {
        ResourceResourceCostCatalog.setBean({
            IDLabour: idLabour
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        ResourceResourceCostCatalog.deleteItemVoid(ResourceResourceCostCatalog.bean.IDResourceResourceCost).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        ResourceResourceCostCatalog.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDResourceResourceCost', visible: true },
        { title: 'Nombre Costo Indirecto', property: 'IndirectCostTypeName', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenter', visible: true },
        { title: 'Unidad de Medida', property: 'CostingMeasurementUnitName', visible: true },
        { title: 'Valor Estandard', property: 'StandardValue', visible: true },
        { title: 'Descripción Costo de Recurso', property: 'ResourceCostDescription', visible: true },


    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${ResourceResourceCostCatalog.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Costos de la Tarea/Operación">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={ResourceResourceCostCatalog.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-12">
                                <label>Costo de Recurso</label>
                                <EditorResourceCost render={ResourceResourceCostCatalog.bean.Name} idSelector={ResourceResourceCostCatalog.bean.IDRawMaterial} onChange={(e) => { ResourceResourceCostCatalog.setBean({ ...ResourceResourceCostCatalog.bean, "IDResourceCost": e.IDResourceCost, "Name": e.Name }) }} label=" " returnType="Object" />
                                {/* <ResourceCostSelect idSelector={ResourceResourceCostCatalog.bean.IDResourceCost} onChange={(e) => { ResourceResourceCostCatalog.setBean({ ...ResourceResourceCostCatalog.bean, "IDResourceCost": e }) }} /> */}
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {ResourceResourceCostCatalog.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}